export type ImageCDNProps = {
  src: string;
  height?: number;
  width?: number | string;
  quality?: number;
  auto?: string;
};

export const formatPhoneNumber = (number: string | null) => {
  if (number == null) {
    return number;
  } else {
    return [number?.slice(0, 2), " ", number?.slice(2, 6), " ", number?.slice(6)].join("");
  }
};

export const capitalizeFirstLetterOfEachWord = (text: string) => {
  return text
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const toKebabCase = (str: string | null): string | null => {
  if (!str) return null;

  return (
    str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+|\b)|[A-Z]?[a-z]+|[0-9]+|[A-Z]/g)
      ?.map((s) => s.toLowerCase())
      .join("-") ?? null
  );
};

export const toTitleCase = (str: string | null): string | null => {
  if (!str) return null;

  return (
    str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+|\b)|[A-Z]?[a-z]+|[0-9]+|[A-Z]/g)
      ?.map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
      .join(" ") ?? null
  );
};

export const toTitleCaseV2 = (str: string | null): string | null => {
  if (!str) return null;

  return (
    str
      .toLowerCase()
      .replace(/\b\w+('\w+)?\b/g, (word) => word.charAt(0).toUpperCase() + word.slice(1)) ?? null
  );
};

export const widgetyImage = (src: string) => {
  return src.startsWith("//") ? `https:${src}` : src;
};
